import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";
import { GET_VENUE_AGENTS_QUERY_KEY } from "./useListVenueAgents";

export const useRevokeVenueAgent = (organizationId: string) => {
    const client = useApiClient();
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (agentId: string) =>
            client.fetchApi<{ success: boolean }, {}>({
                endpoint: `court-recordings/admin/venue-agents/${agentId}?organizationId=${organizationId}`,
                method: 'DELETE',
            }),
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: GET_VENUE_AGENTS_QUERY_KEY(organizationId),
            });
        },
    });
};
